module.exports = __webpack_public_path__ + "img/wechat.16bc3f98.svg";